export default function scrollTopInit() {

  window.onload = () => {

    [...document.querySelectorAll(".js__to-top")].map(v => {
      v.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      });
    })
  };

}